import { color } from '../color';
import { getValue } from '../../get-value';

export const colorBackgroundDefaultTokens: Record<string, string> =
  Object.freeze({
    'color.background.accent.red.bolder': getValue(
      color,
      'default.background.accent.red.bolder'
    ),
    'color.background.accent.red.subtle': getValue(
      color,
      'default.background.accent.red.subtle'
    ),
    'color.background.accent.red.subtler': getValue(
      color,
      'default.background.accent.red.subtler'
    ),
    'color.background.accent.red.subtlest': getValue(
      color,
      'default.background.accent.red.subtlest'
    ),
    'color.background.accent.orange.bolder': getValue(
      color,
      'default.background.accent.orange.bolder'
    ),
    'color.background.accent.orange.subtle': getValue(
      color,
      'default.background.accent.orange.subtle'
    ),
    'color.background.accent.orange.subtler': getValue(
      color,
      'default.background.accent.orange.subtler'
    ),
    'color.background.accent.orange.subtlest': getValue(
      color,
      'default.background.accent.orange.subtlest'
    ),
    'color.background.accent.yellow.bolder': getValue(
      color,
      'default.background.accent.yellow.bolder'
    ),
    'color.background.accent.yellow.subtle': getValue(
      color,
      'default.background.accent.yellow.subtle'
    ),
    'color.background.accent.yellow.subtler': getValue(
      color,
      'default.background.accent.yellow.subtler'
    ),
    'color.background.accent.yellow.subtlest': getValue(
      color,
      'default.background.accent.yellow.subtlest'
    ),
    'color.background.accent.green.bolder': getValue(
      color,
      'default.background.accent.green.bolder'
    ),
    'color.background.accent.green.subtle': getValue(
      color,
      'default.background.accent.green.subtle'
    ),
    'color.background.accent.green.subtler': getValue(
      color,
      'default.background.accent.green.subtler'
    ),
    'color.background.accent.green.subtlest': getValue(
      color,
      'default.background.accent.green.subtlest'
    ),
    'color.background.accent.teal.bolder': getValue(
      color,
      'default.background.accent.teal.bolder'
    ),
    'color.background.accent.teal.subtle': getValue(
      color,
      'default.background.accent.teal.subtle'
    ),
    'color.background.accent.teal.subtler': getValue(
      color,
      'default.background.accent.teal.subtler'
    ),
    'color.background.accent.teal.subtlest': getValue(
      color,
      'default.background.accent.teal.subtlest'
    ),
    'color.background.accent.blue.bolder': getValue(
      color,
      'default.background.accent.blue.bolder'
    ),
    'color.background.accent.blue.subtle': getValue(
      color,
      'default.background.accent.blue.subtle'
    ),
    'color.background.accent.blue.subtler': getValue(
      color,
      'default.background.accent.blue.subtler'
    ),
    'color.background.accent.blue.subtlest': getValue(
      color,
      'default.background.accent.blue.subtlest'
    ),
    'color.background.accent.purple.bolder': getValue(
      color,
      'default.background.accent.purple.bolder'
    ),
    'color.background.accent.purple.subtle': getValue(
      color,
      'default.background.accent.purple.subtle'
    ),
    'color.background.accent.purple.subtler': getValue(
      color,
      'default.background.accent.purple.subtler'
    ),
    'color.background.accent.purple.subtlest': getValue(
      color,
      'default.background.accent.purple.subtlest'
    ),
    'color.background.accent.magenta.bolder': getValue(
      color,
      'default.background.accent.magenta.bolder'
    ),
    'color.background.accent.magenta.subtle': getValue(
      color,
      'default.background.accent.magenta.subtle'
    ),
    'color.background.accent.magenta.subtler': getValue(
      color,
      'default.background.accent.magenta.subtler'
    ),
    'color.background.accent.magenta.subtlest': getValue(
      color,
      'default.background.accent.magenta.subtlest'
    ),
    'color.background.accent.gray.bolder': getValue(
      color,
      'default.background.accent.gray.bolder'
    ),
    'color.background.accent.gray.subtle': getValue(
      color,
      'default.background.accent.gray.subtle'
    ),
    'color.background.accent.gray.subtler': getValue(
      color,
      'default.background.accent.gray.subtler'
    ),
    'color.background.accent.gray.subtlest': getValue(
      color,
      'default.background.accent.gray.subtlest'
    ),
    'color.background.disabled': getValue(color, 'default.background.disabled'),
    'color.background.input': getValue(
      color,
      'default.background.input.default'
    ),
    'color.background.selected': getValue(
      color,
      'default.background.selected.default'
    ),
    'color.background.selected.bold': getValue(
      color,
      'default.background.selected.bold.default'
    ),
    'color.background.brand.bold': getValue(
      color,
      'default.background.brand.bold.default'
    ),
    'color.background.danger': getValue(
      color,
      'default.background.danger.default'
    ),
    'color.background.danger.bold': getValue(
      color,
      'default.background.danger.bold.default'
    ),
    'color.background.warning': getValue(
      color,
      'default.background.warning.default'
    ),
    'color.background.warning.bold': getValue(
      color,
      'default.background.warning.bold.default'
    ),
    'color.background.success': getValue(
      color,
      'default.background.success.default'
    ),
    'color.background.success.bold': getValue(
      color,
      'default.background.success.bold.default'
    ),
    'color.background.discovery': getValue(
      color,
      'default.background.discovery.default'
    ),
    'color.background.discovery.bold': getValue(
      color,
      'default.background.discovery.bold.default'
    ),
    'color.background.information': getValue(
      color,
      'default.background.information.default'
    ),
    'color.background.information.bold': getValue(
      color,
      'default.background.information.bold.default'
    )
  });
